import { render } from "./PolicyLinked.vue?vue&type=template&id=05aba572"
import script from "./PolicyLinked.vue?vue&type=script&lang=js"
export * from "./PolicyLinked.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__